// src/components/atoms/branded-qr-code.tsx
"use client"

import QRCode from "react-qr-code"

type Props = {
  value: string
  size?: number
}

export function BrandedQrCode({ value, size = 192 }: Props) {
  return (
    <div
      className="relative inline-block rounded-lg border bg-white p-2"
      style={{ width: size + 16, height: size + 16 }}
    >
      <QRCode value={value} size={size} fgColor="#2C47E5" level="H" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="rounded bg-white p-1">
          <img
            src="/images/niftipay-icon-blue.svg"
            alt=""
            width={36}
            height={36}
          />
        </div>
      </div>
    </div>
  )
}
